const myApp = {
	// сет брейкпоинтов для js
	// должны совпадать с теми что в body:after
	mediaBreakpoint: {
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200
	},
	init: function() {
		this.detectIE();
		jQuery.extend(jQuery.validator.messages, {
			required: "Это поле обязательое",
			remote: "Пожалуйста, исправьте это поле",
			email: "Пожалуйста, введите действительный адрес электронной почты.",
		});

		this.lazyload();
		this.getVideoPlaceholder();

		if ('objectFit' in document.documentElement.style === false) {
			this.objectFitFallback($('[data-object-fit]'));
		}

		$('.js-tel').mask('+7 (999) 999-99-99', {
			placeholder: '+7 (___) ___-__-__'
		});

		this.mainMenu();
		this.catalogMenu();
		this.sliderMain();
		this.newsSlider();
		this.licenseSlider();
		this.articleSlider();
		this.modalsInit();
		this.informationGrid();
		this.formValidate( $(".js-validate") );
		this.buttons();
		this.closeOnFocusLost();
		this.tabs({
			wrapSelector: '.js-tabs',
			navSelector: '.js-tabs-nav',
			contentSelector: '.js-tabs-content',
		});
		this.initNewTabs();
		this.initNumberMask();
		this.initCalcs();
		this.addMap({
			mapId: '#mapIt',
			// key: 'AIzaSyC3lkwAB0BVbMpEsubfUytOgxEGfqcWtyE',
			function: 'myApp.mapInit',
		})

		myApp.spoiler({
			spoiler: '.js-spoiler',
			spoilerHead: '.js-spoiler-head',
			spoilerBody: '.js-spoiler-body',
			time: 300,
			breakpoint: 768,
			activeClass: 'active'
		});

		let sticky = new Sticky('.js-sticky');
	},

	initBefore: function () {
		this.fullWidth('.js-full-width');
	},

	initOnLoad: function() {
		$('html').removeClass('no-js').addClass('js window-loaded')
		$('.dot').dotdotdot({ watch: 'window' });
	},

	mainMenu: function () {
		const toggleSubMenu = function () {
			$(this).closest('li').toggleClass('is-active')
		}
		$(document).on('click', '.nav__item-icon-1, .nav__item-icon-2', toggleSubMenu)
	},

	initNumberMask: function() {
		const maskInputs = [...document.querySelectorAll('.js-number-mask')];
		const baseOptions = {
			mask: Number,
			signed: false,
			scale: 0,
			min: 0,
			normalizeZeros: true,
			thousandsSeparator: ' ',
		};

		if (maskInputs.length) {
			maskInputs.forEach((input) => {
				const inputType = input.dataset.type;
				const inputOptions = Object.assign({}, baseOptions)

				switch (inputType) {
					case 'weight': {
						inputOptions.scale = 3;
						inputOptions.radix = ',';
						break;
					}
					case 'currency': {
						inputOptions.scale = 2;
						inputOptions.radix = ',';
						break;
					}
					case 'percent': {
						inputOptions.max = 99;
						break;
					}
				}

				IMask(input, inputOptions);
			});
		}
	},

	catalogMenu: function () {
		let ps
		if ($('.catalog-menu__inner').length) {
			ps = new PerfectScrollbar('.catalog-menu__inner', {
				suppressScrollX: true,
				minScrollbarLength: 20
			});
		}

		$(document).on('click', '.catalog-menu__label', function () {
			$(this).parent().toggleClass('active')
			ps.update();
		})
	},

	sliderMain: function () {
		const $slider = $('.js-top-slider');
		const app = this;
		$slider.slick({
			lazyLoad: 'ondemand',
			infinite: true,
			touchThreshold: 10,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			arrows: false,
			dots: true,
			cssEase: 'ease-in-out',
			// autoplay: true,
			// autoplaySpeed: 4000,
			pauseOnHover: false,
		});
		if ('objectFit' in document.documentElement.style === false) {
			$slider.on('lazyLoaded', function (event, slick) {
				app.objectFitFallback($('[data-object-fit]', slick.$slider));
			});
		}
	},

	articleSlider: function () {
		const $slider = $('.article-slider');
		const app = this;
		$slider.slick({
			lazyLoad: 'ondemand',
			touchThreshold: 10,
			slidesToShow: 3,
			slidesToScroll: 3,
			dots: false,
			prevArrow: '<button type="button" class="slick-prev"><svg width="1em" height="1em"><use xlink:href="#si-arrow-left"></use></svg>Previous</button>',
			nextArrow: '<button type="button" class="slick-next">Next<svg width="1em" height="1em"><use xlink:href="#si-arrow-right"></use></svg></button>',
			responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
			]
		})
		if ('objectFit' in document.documentElement.style === false) {
			$slider.on('lazyLoaded', function (event, slick) {
				app.objectFitFallback($('[data-object-fit]', slick.$slider));
			});
		}
	},

	licenseSlider: function () {
		var $slider = $('.license-slider');
		var app = this;
		$slider.slick({
			lazyLoad: 'ondemand',
			touchThreshold: 10,
			slidesToShow: 4,
			slidesToScroll: 4,
			dots: true,
			prevArrow: '<button type="button" class="slick-prev"><svg width="1em" height="1em"><use xlink:href="#si-arrow-left"></use></svg>Previous</button>',
			nextArrow: '<button type="button" class="slick-next">Next<svg width="1em" height="1em"><use xlink:href="#si-arrow-right"></use></svg></button>',
			responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		});
		if ('objectFit' in document.documentElement.style === false) {
			$slider.on('lazyLoaded', function (event, slick) {
				app.objectFitFallback($('[data-object-fit]', slick.$slider));
			});
		}
	},

	newsSlider: function () {
		const $slider = $('.b-news__slider');
		const app = this;
		let trottle = 0;
		let isIninted = 0;
		const init = ($slider) => {
			$slider.slick({
				touchThreshold: 10,
				slidesToShow: 2,
				slidesToScroll: 2,
				prevArrow: '<button type="button" class="slick-prev"><svg width="1em" height="1em"><use xlink:href="#si-arrow-left"></use></svg>Previous</button>',
				nextArrow: '<button type="button" class="slick-next">Next<svg width="1em" height="1em"><use xlink:href="#si-arrow-right"></use></svg></button>',
			})
			if ('objectFit' in document.documentElement.style === false) {
				$slider.on('lazyLoaded', function (event, slick) {
					app.objectFitFallback($('[data-object-fit]', slick.$slider));
				});
			}
		}
		if (app.getScreenSize() >= app.mediaBreakpoint.md) {
			init($slider)
			isIninted = 1;
		}

		$(window).resize(function(){

			clearTimeout(trottle);
			trottle = setTimeout(function () {
				if ( app.getScreenSize() < app.mediaBreakpoint.md) {
					if (isIninted) {
						$slider.slick('unslick');
						isIninted = 0;
					}
				} else if (!isIninted) {
					init($slider);
					isIninted = 1;
				}
			}, 100);
		})
	},

	informationGrid: function () {
		$('.information__grid').masonry({
			itemSelector: '.information__item',
			columnWidth: '.information__grid-sizer',
			percentPosition: true
		})
	},

	buttons: function() {
		const app = this;
		$(document).on('click', '.menu-trigger', function() {
			$('body').toggleClass('nav-showed');
		});
		$(document).on('click', '.header__search-btn', function() {
			const $body = $('body')
			$body.toggleClass('search-showed')
			if ($body.hasClass('search-showed')) {
				setTimeout(function() {
					$('.top-search__input').focus();
				}, 205);
			}
		});
	},

	modalsInit: function () {
		let app = this;
		$('.js-modal-iframe').magnificPopup({
			disableOn: 700,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,

			fixedContentPos: false
		});

		$('.js-modal-image').magnificPopup({
			type: 'image',
			removalDelay: 500,
			callbacks: {
				beforeOpen: function() {
					this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
					this.st.mainClass = this.st.el.attr('data-effect');
				}
			},
			closeOnContentClick: true,
			midClick: true
		});

		let callbacks = {
			ajaxContentAdded: function() {
				const $modalContent = $(this.content);

				$('.js-tel').mask('+7 (999) 999-99-99', {
					placeholder: '+7 (___) ___-__-__'
				});

				app.formValidate( $(".js-validate") );
			},
		};

		$('.js-ajax-modal').magnificPopup({
			type: 'ajax',
			disableOn: 700,
			removalDelay: 150,
			mainClass: 'mfp-fade',
			fixedContentPos: true,
			fixedBgPos: true,
			callbacks: callbacks,
			showCloseBtn: false
		});
	},

	/**
	 * ставит превью видюшки в img внутри селектора
	 * поддерживает прямые ссылки на видео типа
	 * https://vimeo.com/61971077
	 * https://youtube.com/watch?v=bha9iNcsrcA
	 *
	 * @return {array} [массив с видюшками]
	 */
	getVideoPlaceholder: function() {
		let videos = [];
		$('.js-video-thumb').each(function() {
			const $t = $(this)
			const href = $t.attr('href')
			const $img = $t.find('img')
			const domain = url_domain(href)
			if (domain === "youtube.com" || domain === "www.youtube.com") {
				const youtubeVideoId = href.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
				if (youtubeVideoId.length == 11) {
					$img.attr('src', '//img.youtube.com/vi/' + youtubeVideoId + '/0.jpg')
				}
			} else if (domain === "vimeo.com") {
				const match = href.match(/^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/);
				if (match) {
					$.getJSON('http://www.vimeo.com/api/v2/video/' + match[5] + '.json?callback=?', { format: "json" }, function(data) {
						$img.attr('src', data[0].thumbnail_large)
					});
				}
			}

			videos.push(this)
		});
		return videos

		function url_domain(data) {
			var a = document.createElement('a');
			a.href = data;
			return a.hostname;
		};
	},

	formValidate: function ($el){
		const app = this;
		const customSubmit = () => {
			alert('отправка формы')
		}
		const successActions = ($form) => {
			const $formSuccess = $('.form-success', $form)
			$formSuccess.slideDown(200)
			$('button[type="submit"]', $form).prop('disabled', true)
			setTimeout(function() {
				$formSuccess.slideUp(200)
				$form[0].reset();
				$('button[type="submit"]', $form).prop('disabled', false)
			}, 5000);
		}
		$el.each(function () {
			const $form = $(this)
			$form.validate({
				errorLabelContainer: $('.form-error', $form),
				wrapper: 'p',
				// errorElement: 'span',
				highlight: function(element) {
					$(element).addClass("error").parent().addClass("error");
				},
				unhighlight: function(element) {
					$(element).removeClass("error").parent().removeClass("error");
				},
				submitHandler: function () {

					customSubmit();

					successActions($form);

				}
			});
		})
	},

	tabs: function(obj) {
		const $nav = $(obj.navSelector);
		$nav.on('click', 'li:not(.active)', function(e) {
			e.preventDefault();
			$(this)
				.addClass('active').siblings().removeClass('active')
				.closest(obj.wrapSelector)
				.find(obj.contentSelector)
					.removeClass('active')
					.hide(0)
					.eq($(this).index())
						.fadeIn(200)
						.addClass('active');
		});
		$nav.each(function (i, item) {
			$(item).find('li').first().click();
		});
	},

	closeOnFocusLost: function() {
		$(document).click(function(e) {
			var $trg = $(e.target);
			if (!$trg.closest(".nav").length &&
				!$trg.hasClass('menu-trigger')
			) {
				$('body').removeClass('nav-showed');
			}

			if (!$trg.closest(".top-search").length &&
				!$trg.hasClass('header__search-btn')
			) {
				$('body').removeClass('search-showed');
			}

			if (!$trg.closest(".catalog-menu").length ) {
				$('.catalog-menu').removeClass('active');
			}
		});
	},

	/**
	 * подключает гугл апи карт, если есть ID
	 * @param {object} obj mapId: string (Id карты)
	 *                     key: string (api key)
	 *                     function: string (название функции инициализации)
	 */
	addMap: function(obj) {
		if ($(obj.mapId).length) {
			$('body').append('<script src="//maps.googleapis.com/maps/api/js?' + (obj.key ? 'key='+obj.key+'&' : '') + 'callback=' + obj.function+'" async="" defer=""></script>');
		}
	},

	mapInit: function() {
		const $map = $('#mapIt');
		const mapData = $map.data();
		const latLng = { lat: -34.397, lng: 150.644 }
		const map = new google.maps.Map($map[0], {
			zoom: 15,
			center: latLng,
			disableDefaultUI: true,
			zoomControl: true,
			fullscreenControl: true
		});

		const geocoder = new google.maps.Geocoder();

		/*const afterGeocode = function (results) {
			const latLng = results[0].geometry.location
			map.setCenter(latLng);
			myApp.mapAddMarker(map, mapData, latLng)
		}*/
		// myApp.geocodeAddress(geocoder, data, afterGeocode);

		map.setCenter(latLng);
		myApp.mapAddMarker(map, mapData, latLng)
	},

	geocodeAddress: function(geocoder, data, cb) {
		geocoder.geocode({ 'address': data.address }, function(results, status) {
			if (status === 'OK') {
				cb(results)
			} else {
				alert('Geocode was not successful for the following reason: ' + status);
			}
		});
	},

	mapAddMarker: function (map, data, latLng) {
		const infowindow = new google.maps.InfoWindow();
		const contentString = ''
		+'<div class="map-info">'
		+'<div>'+data.title+'</div>'
		+'</div>'
		;
		const marker = new google.maps.Marker({
			map: map,
			position: latLng,
			title: data.title,
			icon: data.icon
		});

		google.maps.event.addListener(marker, 'click', function() {
			infowindow.setContent(contentString);
			infowindow.open(map, marker);
		});
	},

	spoiler: function(obj) {
		const activeClass = obj.activeClass;
		const $spoilers = $(obj.spoiler);
		const $bodys = $(obj.spoilerBody);
		const time = obj.time;

		$(document).on('click', obj.spoilerHead, function() {
			const $t = $(this);
			const $thatSpoiler = $t.closest(obj.spoiler);
			if (!$thatSpoiler.hasClass(activeClass) &&
				$(window).width() >= obj.breakpoint
			) {
				$spoilers.removeClass(activeClass);
				$bodys.slideUp(time);
				$thatSpoiler.toggleClass(activeClass)
					.find(obj.spoilerBody).slideToggle(time, obj.afterToggle);
			} else {
				$thatSpoiler.toggleClass(activeClass)
					.find(obj.spoilerBody).slideToggle(time, obj.afterToggle);
			}
		});
	},

	lazyload: function() {
		try {
			lazyload();
		} catch (e) {
			console.log('lazyload fallback');
			$('.lazyload').each(function() {
				const $t = $(this);
				const src = $(this).attr('src');
				const dataSrc = $t.data().src;
				if (typeof src !== typeof undefined && src !== false && $t.is('img')) {
					$t.attr('src', dataSrc)
				} else {
					$t.css({
						'background-image': 'url(' + dataSrc + ')'
					});
				}

			});
		}
	},

	objectFitFallback: function(selector) {
		for (var i = 0; i < selector.length; i++) {
			const that = selector[i]
			const imgUrl = that.getAttribute('src') ? that.getAttribute('src') : that.getAttribute('data-src');
			const dataFit = that.getAttribute('data-object-fit')
			let fitStyle
			if (dataFit === 'cover') {
				fitStyle = 'cover'
			} else {
				fitStyle = 'contain'
			}
			const parent = that.parentElement
			if (imgUrl) {
				parent.style.backgroundImage = 'url(' + imgUrl + ')'
				parent.classList.add('fit-img')
				parent.classList.add('fit-img--'+fitStyle)
			}
		};
	},

	fullWidth: function(selector) {
		let trottle;
		const $elements = $(selector);
		const fit = () => {
			$.each($elements, function(key, item) {
				const $el = $(this);
				if ($el.data('full-width-inited') !== "Y") {
					$el.after('<div class="full-width-calculate"></div>');
				}
				const $el_full = $el.next('.full-width-calculate');
				if ($el_full.length) {
					const el_margin_left = parseInt($el.css("margin-left"), 10),
						el_margin_right = parseInt($el.css("margin-right"), 10),
						offset = 0 - $el_full.offset().left - el_margin_left,
						width = $(window).width();
					if ($el.css({
							position: "relative",
							left: offset,
							"box-sizing": "border-box",
							width: $(window).width()
						}), !$el.data("vcStretchContent")) {
						let padding = -1 * offset;
						0 > padding && (padding = 0);
						let paddingRight = width - padding - $el_full.width() + el_margin_left + el_margin_right;
						0 > paddingRight && (paddingRight = 0),
							$el.css({
								"padding-left": padding + "px",
								"padding-right": paddingRight + "px"
							})
					}
					$el.data("full-width-inited", "Y");
				}
			});
		}

		fit();
		$(window).on('resize', function() {
			clearTimeout(trottle);
			trottle = setTimeout(function() {
				fit();
			}, 100);
		})
	},

	detectIE: function() {
		/**
		 * detect IE
		 * returns version of IE or false, if browser is not Internet Explorer
		 */

		 (function detectIE() {
		 	var ua = window.navigator.userAgent;

		 	var msie = ua.indexOf('MSIE ');
		 	if (msie > 0) {
				// IE 10 or older => return version number
				var ieV = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
				document.querySelector('body').className += ' IE';
			}

			var trident = ua.indexOf('Trident/');
			if (trident > 0) {
				// IE 11 => return version number
				var rv = ua.indexOf('rv:');
				var ieV = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
				document.querySelector('body').className += ' IE';
			}

			var edge = ua.indexOf('Edge/');
			if (edge > 0) {
				// IE 12 (aka Edge) => return version number
				var ieV = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
				document.querySelector('body').className += ' IE';
			}

			// other browser
			return false;
		})();
	},

	getScrollbarSize: function() {
		let scrollbarSize;
		if (scrollbarSize === undefined) {
			const scrollDiv = document.createElement('div');
			scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
			document.body.appendChild(scrollDiv);
			scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
			document.body.removeChild(scrollDiv);
		}
		return scrollbarSize;
	},

	getScreenSize: function() {
		let screenSize =
			window
			.getComputedStyle(document.querySelector('body'), ':after')
			.getPropertyValue('content');
		screenSize = parseInt(screenSize.match(/\d+/));
		return screenSize;
	},

	initNewTabs: function() {
		$('.js-new-tabs').responsiveTabs({
			setHash: true,
			active: 0,
			animation: 'fade',
			duration: 300,
		});
	},

	initCalcs: function() {
		const calcs = [...document.querySelectorAll('.js-calculator')];

		if (calcs.length) {
			calcs.forEach((calc) => {
				const type = calc.dataset.type;

				switch(type) {
					case 'probitox-cattle':
						new ProbitoxCattleCalc(calc);
						break;
					case 'probitox-pig':
						new ProbitoxPigCalc(calc);
						break;
					case 'probitox-bird':
						new ProbitoxBirdCalc(calc);
						break;
					case 'lipid':
						new LipidCalc(calc);
						break;
					default:
						console.error('Неизвестный тип калькулятора!');
				}
			});
		}
	}
};

myApp.initBefore();

$(function() {
	myApp.init();
});

$(window).on('load', function() {
	myApp.initOnLoad();
});

Number.isNaN = Number.isNaN || function(value) {
	return typeof value === 'number' && isNaN(value);
}

class Calculator {
	constructor(el) {
		this.el = el;
		this.resultButton = this.el.querySelector('.js-result-button');
		this.isReadyCalculate = false;
	}

	getPropNameFromId(id) {
		return id.split('-').slice(1).map((item, index) => index !== 0 ? `${item[0].toUpperCase()}${item.slice(1)}` : item).join('');
	}

	getNumberFromString(strValue) {
		const numbValue = parseFloat(strValue);

		return Number.isNaN(numbValue) ? null : numbValue;
	}

	setValueFromControl(control) {
		const propName = this.getPropNameFromId(control.id);
		const value = this.getNumberFromString(control.value.replace(/,/, '.').split(' ').join(''));

		this[propName] = value;
	}
}

class ProbitoxCattleCalc extends Calculator {
	constructor(el) {
		super(el);
		this.milkingYear = null;
		this.moisturePersentage = null;
		this.liveStock = null;
		this.intoxication = null;
		this.feedIntakeDay = null;
		this.resultDay = null;
		this.resultMonth = null;

		this.init();
	}

	init() {
		this.resultButton.disabled = !this.isReadyCalculate;

		[...this.el.querySelectorAll('.js-calculator-field')].forEach((control) => {
			this.setValueFromControl(control);
		});

		this.el.addEventListener('input', (evt) => {
			if (evt.target.classList.contains('js-calculator-field')) {
				this.setValueFromControl(evt.target);
			}
		});

		this.resultButton.addEventListener('click', (evt) => {
			evt.preventDefault();
			if (this.isReadyCalculate) {
				this.calculate();
			}
		});
	}

	setValueFromControl(control) {
		super.setValueFromControl(control);
		this.calculateFeedInyakeDay();
		this.changeReadyState();
	}

	calculateFeedInyakeDay() {
		const feedIntakeDayInput = this.el.querySelector('.js-feed-day');
		if (this.milkingYear && this.moisturePersentage) {
			const persent = (100 - this.moisturePersentage) / 100;
			const value = (((this.milkingYear - 4000) / 666.66) + 12) / persent;
			const roundValue = parseFloat(value.toFixed(2));

			this.feedIntakeDay = value;
			feedIntakeDayInput.value = formatNumber(roundValue);
		} else {
			this.feedIntakeDay = null;
			feedIntakeDayInput.value = '';
		}
	}

	changeReadyState() {
		if (this.milkingYear && this.moisturePersentage && this.liveStock && this.intoxication && this.feedIntakeDay) {
			this.isReadyCalculate = true;
		} else {
			this.isReadyCalculate = false;
			this.clearResults();
		}
		this.resultButton.disabled = !this.isReadyCalculate;
	}

	clearResults() {
		const resultDayBlock = this.el.querySelector('.js-calc-result-day');
		const resultMonthBlock = this.el.querySelector('.js-calc-result-month');

		resultDayBlock.textContent = '';
		resultMonthBlock.textContent = '';
	}

	calculate() {
		const resultDayBlock = this.el.querySelector('.js-calc-result-day');
		const resultMonthBlock = this.el.querySelector('.js-calc-result-month');
		const normaDay = this.feedIntakeDay * this.intoxication;
		const volumeDay = this.liveStock * normaDay;
		const normaMonth = volumeDay * 30 / 1000;

		this.resultDay = parseFloat(normaDay.toFixed(4));
		this.resultMonth = parseFloat(normaMonth.toFixed(4));
		resultMonthBlock.textContent = formatNumber(this.resultMonth);
		resultDayBlock.textContent = formatNumber(this.resultDay);
	}
}

class ProbitoxPigCalc extends Calculator {
	constructor(el) {
		super(el);
		this.monthlyLivestock = null;
		this.feedIntake = null;
		this.intoxication = null;
		this.monthlyFeedIntake = null;
		this.resultDay = null;
		this.resultMonth = null;

		this.init();
	}

	init() {
		this.resultButton.disabled = !this.isReadyCalculate;

		[...this.el.querySelectorAll('.js-calculator-field')].forEach((control) => {
			this.setValueFromControl(control);
		});

		this.el.addEventListener('input', (evt) => {
			if (evt.target.classList.contains('js-calculator-field')) {
				this.setValueFromControl(evt.target);
			}
		});

		this.resultButton.addEventListener('click', (evt) => {
			evt.preventDefault();
			if (this.isReadyCalculate) {
				this.calculate();
			}
		});
	}

	setValueFromControl(control) {
		super.setValueFromControl(control);
		this.calculateFeedInyake();
		this.changeReadyState();
	}

	calculateFeedInyake() {
		const monthlyFeedIntakeInput = this.el.querySelector('.js-feed');
		if (this.monthlyLivestock && this.feedIntake) {
			const result = this.monthlyLivestock * this.feedIntake;
			const roundValue = parseFloat(result.toFixed(2));

			this.monthlyFeedIntake = result;
			monthlyFeedIntakeInput.value = formatNumber(roundValue);
		} else {
			this.monthlyFeedIntake = null;
			monthlyFeedIntakeInput.value = '';
		}
	}

	changeReadyState() {
		if (this.monthlyLivestock && this.feedIntake && this.intoxication && this.monthlyFeedIntake) {
			this.isReadyCalculate = true;
		} else {
			this.isReadyCalculate = false;
			this.clearResults();
		}
		this.resultButton.disabled = !this.isReadyCalculate;
	}

	clearResults() {
		const resultDayBlock = this.el.querySelector('.js-calc-result-day');
		const resultMonthBlock = this.el.querySelector('.js-calc-result-month');

		resultDayBlock.textContent = '';
		resultMonthBlock.textContent = '';
	}

	calculate() {
		const resultBlockDay = this.el.querySelector('.js-calc-result-day');
		const resultBlockMonth = this.el.querySelector('.js-calc-result-month');
		const normaDay = this.feedIntake * this.intoxication;
		const volumeDay = this.monthlyLivestock * normaDay;
		const normaMonth = volumeDay * 30;
		const adsorbent_rate = normaMonth * 1000 / this.monthlyFeedIntake;

		//this.resultDay = parseFloat(normaDay.toFixed(4))
		this.resultDay = parseFloat(adsorbent_rate.toFixed(4));
		this.resultMonth = parseFloat(normaMonth.toFixed(4));
		resultBlockDay.textContent = formatNumber(this.resultDay) + ',0';
		resultBlockMonth.textContent = formatNumber(this.resultMonth);
	}
}

class ProbitoxBirdCalc extends Calculator {
	constructor(el) {
		super(el);
		this.directionProductivity = null;
		this.monthlyLivestock = null;
		this.intoxication = null;
		this.monthlyFeedIntake = null;
		this.resultDay = null;
		this.resultMonth = null;

		this.init();
	}

	init() {
		this.resultButton.disabled = !this.isReadyCalculate;

		[...this.el.querySelectorAll('.js-calculator-field')].forEach((control) => {
			this.setValueFromControl(control);
		});

		this.el.addEventListener('input', (evt) => {
			if (evt.target.classList.contains('js-calculator-field')) {
				this.setValueFromControl(evt.target);
			}
		});

		this.resultButton.addEventListener('click', (evt) => {
			evt.preventDefault();
			if (this.isReadyCalculate) {
				this.calculate();
			}
		});
	}

	setValueFromControl(control) {
		super.setValueFromControl(control);
		this.calculateMonthlyFeedIntake();
		this.changeReadyState();
	}

	calculateMonthlyFeedIntake() {
		const feedIntakeInput = this.el.querySelector('.js-feed-intake-result');
		if (this.monthlyLivestock && this.directionProductivity) {
			const result = this.monthlyLivestock * this.directionProductivity * 30;
			const roundValue = parseFloat(result.toFixed(2));

			this.monthlyFeedIntake = result;
			feedIntakeInput.value = formatNumber(roundValue);
		} else {
			this.monthlyFeedIntake = null;
			feedIntakeInput.value = '';
		}
	}

	changeReadyState() {
		if (this.directionProductivity && this.monthlyLivestock && this.intoxication && this.monthlyFeedIntake) {
			this.isReadyCalculate = true;
		} else {
			this.isReadyCalculate = false;
			this.clearResults();
		}
		this.resultButton.disabled = !this.isReadyCalculate;
	}

	clearResults() {
		const resultDayBlock = this.el.querySelector('.js-calc-result-day');
		const resultMonthBlock = this.el.querySelector('.js-calc-result-month');

		resultDayBlock.textContent = '';
		resultMonthBlock.textContent = '';
	}

	calculate() {
		const resultBlockDay = this.el.querySelector('.js-calc-result-day');
		const resultBlockMonth = this.el.querySelector('.js-calc-result-month');
		const normaDay = this.monthlyFeedIntake / this.monthlyLivestock * this.intoxication;
		console.log(`monthlyFeedIntake2 = ${ this.monthlyFeedIntake }`);
		const volumeDay = this.monthlyLivestock * normaDay;
		const normaMonth = volumeDay * 30;
		const adsorbent_rate = normaMonth * 1000 / this.monthlyFeedIntake;

		//this.resultDay = parseFloat(normaDay.toFixed(4));
		this.resultDay = parseFloat(adsorbent_rate.toFixed(4));
		this.resultMonth = parseFloat(normaMonth.toFixed(4));
		resultBlockDay.textContent = formatNumber(this.resultDay) + ',0';
		resultBlockMonth.textContent = formatNumber(this.resultMonth);
	}
}

class LipidCalc extends Calculator {
	constructor(el) {
		super(el);
		this.additionalEnergy = {
			'0.5': 44300,
			'0.6': 50440,
			'0.7': 56580,
			'0.8': 62720,
			'0.9': 68860,
			'1': 75000
		};
		this.cleanEnergy = null;
		this.inputOilFat = null;
		this.priceLipid = null;
		this.priceOilFat = null;
		this.norma = null;

		this.actualOilInput = null;

		this.resultVolume = null;
		this.resultSaving = null;

		this.error = false;

		this.init();
	}

	init() {
		this.resultButton.disabled = !this.isReadyCalculate;

		[...this.el.querySelectorAll('.js-calculator-field')].forEach((control) => {
			this.setValueFromControl(control);
		});

		this.el.addEventListener('input', (evt) => {
			if (evt.target.classList.contains('js-calculator-field')) {
				this.setValueFromControl(evt.target);
			}
			if (evt.target.classList.contains('js-calc-min-validate')) {
				this.validateMinValue(evt.target, parseFloat(evt.target.dataset.min));
			}
		});

		this.resultButton.addEventListener('click', (evt) => {
			evt.preventDefault();
			if (this.isReadyCalculate) {
				this.calculate();
			}
		});
	}

	validateMinValue(el, min) {
		const value = parseFloat(el.value);

		if (value < min) {
			el.parentElement.classList.add('error');
		} else {
			el.parentElement.classList.remove('error');
		}

		this.error = value < min;
		this.changeReadyState();
	}

	setValueFromControl(control) {
		super.setValueFromControl(control);
		this.calculateActualOilInput();
		this.changeReadyState();
	}

	calculateActualOilInput() {
		const volumeOilChangeLipid = this.additionalEnergy[this.norma] / this.cleanEnergy;
		const result = this.inputOilFat - volumeOilChangeLipid;

		this.actualOilInput = parseFloat(result.toFixed(2));
	}

	changeReadyState() {
		if (this.inputOilFat && this.actualOilInput && this.priceOilFat && this.norma && this.priceLipid && !this.error) {
			this.isReadyCalculate = true;
		} else {
			this.isReadyCalculate = false;
			this.clearResults();
		}
		this.resultButton.disabled = !this.isReadyCalculate;
	}

	clearResults() {
		const resultVolumeBlock = this.el.querySelector('.js-calc-result-volume');
		const resultSavingBlock = this.el.querySelector('.js-calc-result-saving');

		resultVolumeBlock.textContent = '';
		resultSavingBlock.textContent = '';
	}

	calculate() {
		const resultVolumeBlock = this.el.querySelector('.js-calc-result-volume');
		const resultSavingBlock = this.el.querySelector('.js-calc-result-saving');
		const volume = this.inputOilFat - this.actualOilInput;
		this.resultVolume = parseFloat(volume.toFixed(2));
		const saving = this.resultVolume * this.priceOilFat - this.priceLipid * this.norma;
		this.resultSaving = parseFloat(saving.toFixed(2));

		resultVolumeBlock.textContent = formatNumber(this.resultVolume);
		resultSavingBlock.textContent = formatNumber(this.resultSaving);
	}
}

function formatNumber(value) {
	const formatter = new Intl.NumberFormat('ru', {
		maximumFractionDigits: 4,
	});
	console.log(`value = ${value}`);
	console.log(`value_format = ${Math.ceil(value)}`);
	return formatter.format(Math.ceil(value));
}
